"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CryptoJS = require("crypto-js");
var ByteArray_1 = require("../byte/ByteArray");
var IFlyBase_1 = require("./IFlyBase");
var js_base64_1 = require("js-base64");
var fast_xml_parser_1 = require("fast-xml-parser");
var axios_1 = require("axios");
var FlyType;
(function (FlyType) {
    FlyType[FlyType["Iat"] = 0] = "Iat";
    FlyType[FlyType["Ise"] = 1] = "Ise";
})(FlyType = exports.FlyType || (exports.FlyType = {}));
var IFly = (function (_super) {
    __extends(IFly, _super);
    function IFly() {
        var _this = _super.call(this) || this;
        _this.isRetrying = false;
        _this.buffer = new ByteArray_1.ByteArray(IFly.BUFFER_LENGTH);
        _this.accent = 'mandarin';
        _this.appId = '5ddf3ed7';
        _this.apiKey = 'd74cfa9794091406feab2aaedbb4f5a0';
        _this.apiSecret = '01eeb05c2678aa1dede40ced2ebed008';
        _this.txId = 'AKIDYzGLEuH3MI8mDSkjaKsFUqP7f0BVamgQ';
        _this.txKey = 'umX8XkmdP4Yu56awJZh6LOFxTnvseFgw';
        _this.aliKey = 'APPCODE 530151b0686240b7aa0c0ab12984c76b';
        return _this;
    }
    IFly.prototype.start = function (isConnectIfly, language, flyType, info, from) {
        if (isConnectIfly === void 0) { isConnectIfly = true; }
        if (language === void 0) { language = 'zh_cn'; }
        if (flyType === void 0) { flyType = 'iat'; }
        if (from === void 0) { from = 'ifly'; }
        this.info = info;
        this.platform = from;
        if (flyType === 'ise') {
            this.testContent = info.standardanswer.replace(/&#39/g, "'");
        }
        _super.prototype.start.call(this, isConnectIfly, language);
        if (this.platform === 'tencent') {
            this.startTX();
        }
        this.isConnectIfly = isConnectIfly;
        this.flyType = flyType;
        this.apdText = '';
        this.showText = '';
        this.lastCode = -1;
        this.showGrade = null;
        this.buffer.reset();
        this.emit(IFly.SOCKET_OPEN);
    };
    IFly.prototype.stop = function (isSubmit) {
        if (isSubmit === void 0) { isSubmit = true; }
        _super.prototype.stop.call(this, isSubmit);
        if (!isSubmit) {
            return;
        }
        if (!this.isConnectIfly) {
            this.showText = '客户端识别功能关闭';
            this.lastCode = 0;
            this.submitResult();
            return;
        }
        this.connectTime = Date.now();
        if (this.platform === 'ifly') {
            this.startFly();
        }
        else if (this.platform === 'tencent') {
            this.stopTX();
        }
        else if (this.platform === 'aliyun') {
            this.stopAli();
        }
    };
    IFly.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this.transaction = this.transaction.bind(this);
        this.recorder.onprogress = function (params) {
            _this.buffer.write(_this.transaction(params.raw));
        };
    };
    IFly.prototype.createRecorder = function (cb) {
        var params = this.getParams();
        if (!params)
            return;
        params.success = function (res) {
            cb();
        };
        params.error = function (err) {
            console.log('腾讯组件创建失败：', err);
        };
        this.recorderTX = new TencentSOE(params);
    };
    IFly.prototype.startTX = function () {
        var _this = this;
        var startFun = function () {
            _this.recorderTX.start({
                RefText: _this.testContent,
                error: function (err) {
                    console.log('腾讯评测失败：', err);
                },
                complete: function (res) { },
                success: function (res) {
                    console.log('腾讯评测start：', res);
                },
            });
        };
        if (!this.recorderTX) {
            this.createRecorder(function () {
                startFun();
            });
        }
        else {
            var params = this.getParams();
            if (params) {
                this.recorderTX.reset(params);
                startFun();
            }
        }
    };
    IFly.prototype.stopTX = function () {
        var _this = this;
        this.recorderTX.stop({
            success: function (res) {
                console.log('腾讯评测stop：', res);
                _this.recorderTX.resLM = res;
                _this.lastCode = 0;
                _this.sendMessage(res);
            },
            error: function (err) {
                if (err.hasOwnProperty('code') && err.code !== 10010) {
                    _this.lastCode = err.code;
                    _this.sendMessage({});
                }
                if (err.hasOwnProperty('code') && err.code === 10010) {
                    _this.emit(IFlyBase_1.IFlyBase.SOCKET_ERROR, err);
                }
            },
        });
    };
    IFly.prototype.getParams = function () {
        return {
            EvalMode: this.info.wordtype === 'read_word' ? 1 : 1,
            ScoreCoeff: 2.0,
            SecretId: this.txId,
            SecretKey: this.txKey,
            ServerType: this.language === 'zh_cn' ? 1 : 0,
            SoeAppId: '',
            StorageMode: 0,
            TextMode: 0,
            WorkMode: 1,
        };
    };
    IFly.prototype.stopAli = function () {
        var _this = this;
        var model;
        if (this.language === 'zh_cn') {
            model = this.info.wordtype === 'read_word' ? 'cn.word.score' : 'cn.sent.score';
        }
        else {
            model = this.info.wordtype === 'read_word' ? 'en.word.score' : 'en.sent.score';
        }
        var reader = new FileReader();
        reader.onload = function (e) {
            var d = e.target.result;
            axios_1.default
                .post("https://evaluation.market.alicloudapi.com/evaluation/realtime?ref_text=" + _this.testContent + "&sample_rate=16000&format=wav&model_id=" + model, d, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: _this.aliKey,
                },
            })
                .then(function (response) {
                _this.lastCode = 0;
                if (response.data.data.payload) {
                    _this.sendMessage(response.data.data.payload);
                }
                else {
                    _this.reStartFly();
                    _this.lastCode = response.data.data.status.code;
                    _this.sendMessage({});
                }
            })
                .catch(function (e) {
                console.log('aliNet error：', e);
                _this.emit(IFlyBase_1.IFlyBase.SOCKET_ERROR, e);
            });
        };
        reader.readAsArrayBuffer(this.recorder.getWAVBlob());
    };
    IFly.prototype.reStartFly = function () {
        var _this = this;
        if (this.isRetrying)
            return;
        if (Date.now() - this.connectTime >= 10 * 1000)
            return;
        this.buffer.resetRead();
        var t = Math.floor(Math.random() * 3) + 1;
        console.log('重新连接中....', t);
        setTimeout(function () {
            _this.retryStop();
            _this.isRetrying = true;
        }, t * 1000);
    };
    IFly.prototype.retryStop = function () {
        if (this.platform === 'ifly') {
            this.startFly();
        }
        else if (this.platform === 'tencent') {
            console.log('tencent不支持重试');
        }
        else if (this.platform === 'aliyun') {
            this.stopAli();
        }
    };
    IFly.prototype.startFly = function () {
        this.isRetrying = false;
        console.log('开始fly', this.flyType);
        if (this.flyType === 'iat') {
            this.connectWebsocket(this.iatUrl());
        }
        else if (this.flyType === 'ise') {
            this.connectWebsocket(this.iseUrl());
        }
    };
    IFly.prototype.iseUrl = function () {
        var url = 'wss://ise-api.xfyun.cn/v2/open-ise';
        var host = 'ise-api.xfyun.cn';
        var date = new Date().toUTCString();
        var signatureOrigin = "host: " + host + "\ndate: " + date + "\nGET /v2/open-ise HTTP/1.1";
        var apiKey = this.apiKey;
        var apiSecret = this.apiSecret;
        var algorithm = 'hmac-sha256';
        var headers = 'host date request-line';
        var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
        var signature = CryptoJS.enc.Base64.stringify(signatureSha);
        var authorizationOrigin = "api_key=\"" + apiKey + "\", algorithm=\"" + algorithm + "\", headers=\"" + headers + "\", signature=\"" + signature + "\"";
        var authorization = btoa(authorizationOrigin);
        url = url + "?authorization=" + authorization + "&date=" + date + "&host=" + host;
        return url;
    };
    IFly.prototype.iatUrl = function () {
        var url = 'wss://iat-api.xfyun.cn/v2/iat';
        var host = 'iat-api.xfyun.cn';
        var date = new Date().toUTCString();
        var signatureOrigin = "host: " + host + "\ndate: " + date + "\nGET /v2/iat HTTP/1.1";
        var apiKey = this.apiKey;
        var apiSecret = this.apiSecret;
        var algorithm = 'hmac-sha256';
        var headers = 'host date request-line';
        var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
        var signature = CryptoJS.enc.Base64.stringify(signatureSha);
        var authorizationOrigin = "api_key=\"" + apiKey + "\", algorithm=\"" + algorithm + "\", headers=\"" + headers + "\", signature=\"" + signature + "\"";
        var authorization = btoa(authorizationOrigin);
        url = url + "?authorization=" + authorization + "&date=" + date + "&host=" + host;
        return url;
    };
    IFly.prototype.submitResult = function () {
        console.log('结果：', this.lastCode, this.showText, this.showGrade);
        if (this.flyType === 'ise' && this.lastCode !== 0) {
            this.reStartFly();
        }
        if (this.flyType === 'iat') {
            this.emit(IFlyBase_1.IFlyBase.MESSAGE, { result: this.showText, code: this.lastCode });
        }
        else {
            this.sendMessage(this.showGrade);
        }
    };
    IFly.prototype.sendMessage = function (res) {
        if (!res) {
            return;
        }
        var msg = {
            isEn: this.language === 'zh_cn' ? 1 : 0,
            isWord: this.info.wordtype === 'read_word' ? 0 : 1,
        };
        try {
            if (this.platform === 'ifly') {
                var resultData = this.language === 'zh_cn'
                    ? res.xml_result.read_sentence.rec_paper.read_sentence
                    : res.xml_result.read_sentence.rec_paper.read_chapter;
                var full = this.language === 'zh_cn' ? resultData.phone_score : resultData.accuracy_score;
                msg.completion = !resultData ? -1 : resultData.integrity_score;
                msg.fluency = !resultData ? -1 : resultData.fluency_score;
                msg.fullness = !resultData ? -1 : full;
                msg.star = !resultData ? -1 : resultData.total_score;
            }
            else if (this.platform === 'tencent') {
                msg.completion = !res.hasOwnProperty('PronCompletion') ? -1 : res.PronCompletion;
                msg.fluency = !res.hasOwnProperty('PronFluency') ? -1 : res.PronFluency;
                msg.fullness = !res.hasOwnProperty('PronAccuracy') ? -1 : res.PronAccuracy;
                msg.star = !res.hasOwnProperty('SuggestedScore') ? -1 : res.SuggestedScore;
            }
            else if (this.platform === 'aliyun') {
                msg.completion = !res.hasOwnProperty('integrity') ? -1 : res.integrity;
                msg.fluency = !res.hasOwnProperty('fluency') ? -1 : res.fluency;
                msg.fullness = !res.hasOwnProperty('accuracy') ? -1 : res.accuracy;
                msg.star = !res.hasOwnProperty('overall') ? -1 : res.overall;
            }
        }
        catch (e) {
            msg.completion = 0;
            msg.fluency = 0;
            msg.fullness = 0;
            msg.star = -1;
        }
        this.emit(IFlyBase_1.IFlyBase.MESSAGE, { result: msg, code: this.lastCode });
    };
    IFly.prototype.connectWebsocket = function (url) {
        var _this = this;
        if ('WebSocket' in window) {
            this.ws = new WebSocket(url);
        }
        else if ('MozWebSocket' in window) {
            this.ws = new MozWebSocket(url);
        }
        else {
            console.log('不支持socket通信');
            return null;
        }
        this.ws.onopen = function (e) {
            console.log('连接ws');
            setTimeout(function () {
                if (_this.flyType === 'iat') {
                    _this.iatSend();
                }
                else {
                    _this.iseSend();
                }
            }, 500);
        };
        this.ws.onmessage = function (e) {
            _this.wsOnMessage(e);
            if (_this.flyType === 'iat') {
                _this.iatResult(e);
            }
            else {
                _this.iseResult(e);
            }
        };
        this.ws.onerror = function (e) {
            console.log('socket error', e);
            _this.emit(IFlyBase_1.IFlyBase.SOCKET_ERROR, e);
        };
        this.ws.onclose = function (e) {
            console.log('socket close');
            _this.submitResult();
            _this.emit(IFlyBase_1.IFlyBase.SOCKET_CLOSE, e);
        };
    };
    IFly.prototype.iatSend = function () {
        var _this = this;
        if (this.ws.readyState !== WebSocket.OPEN) {
            return;
        }
        var audioData = this.buffer.read(IFlyBase_1.IFlyBase.BYTE_LENGTH);
        var params = {
            common: {
                app_id: this.appId,
            },
            business: {
                language: this.language,
                domain: 'iat',
                accent: this.accent,
                vad_eos: 5000,
                dwa: 'wpgs',
            },
            data: {
                status: 0,
                format: 'audio/L16;rate=16000',
                encoding: 'raw',
                audio: this.buffer2Base64(audioData),
            },
        };
        this.ws.send(JSON.stringify(params));
        this.handlerInterval = setInterval(function () {
            if (_this.ws.readyState !== WebSocket.OPEN) {
                clearInterval(_this.handlerInterval);
                return;
            }
            console.log('sending...');
            if (_this.buffer.length === 0) {
                console.log('end');
                _this.ws.send(JSON.stringify({
                    data: {
                        status: 2,
                        format: 'audio/L16;rate=16000',
                        encoding: 'raw',
                        audio: '',
                    },
                }));
                clearInterval(_this.handlerInterval);
            }
            var audioDataII = _this.buffer.read(IFlyBase_1.IFlyBase.BYTE_LENGTH);
            _this.ws.send(JSON.stringify({
                data: {
                    status: 1,
                    format: 'audio/L16;rate=16000',
                    encoding: 'raw',
                    audio: _this.buffer2Base64(audioDataII),
                },
            }));
        }, 40);
    };
    IFly.prototype.wsOnMessage = function (e) {
        var jsonData = JSON.parse(e.data);
        if (jsonData.code === 0 && jsonData.data.status === 2) {
            this.ws.close();
        }
        if (jsonData.code !== 0) {
            this.ws.close();
            this.emit(IFlyBase_1.IFlyBase.CODE_ERROR, jsonData);
            console.log(jsonData.code + ":" + jsonData.message);
        }
    };
    IFly.prototype.iatResult = function (e) {
        var jsonData = JSON.parse(e.data);
        var str = '';
        this.lastCode = jsonData.code;
        if (jsonData.data && jsonData.data.result) {
            var data = jsonData.data.result;
            var ws = data.ws;
            for (var i = 0; i < ws.length; i++) {
                str = str + ws[i].cw[0].w;
            }
            if (data.pgs === 'apd') {
                this.apdText = this.showText;
            }
            this.showText = this.apdText + str;
        }
    };
    IFly.prototype.iseSend = function () {
        var _this = this;
        if (this.ws.readyState !== WebSocket.OPEN) {
            return;
        }
        var params = {
            common: {
                app_id: this.appId,
            },
            business: {
                category: 'read_sentence',
                rstcd: 'utf8',
                group: 'pupil',
                sub: 'ise',
                ent: this.language === 'zh_cn' ? 'cn_vip' : 'en_vip',
                tte: 'utf-8',
                cmd: 'ssb',
                auf: 'audio/L16;rate=16000',
                aus: 1,
                aue: 'raw',
                text: '\uFEFF' + this.testContent,
            },
            data: {
                status: 0,
                encoding: 'raw',
                data_type: 1,
                data: '',
            },
        };
        this.ws.send(JSON.stringify(params));
        this.handlerInterval = setInterval(function () {
            if (_this.ws.readyState !== WebSocket.OPEN) {
                clearInterval(_this.handlerInterval);
                return;
            }
            if (_this.buffer.length === 0) {
                _this.ws.send(JSON.stringify({
                    business: {
                        cmd: 'auw',
                        aus: 4,
                        aue: 'raw',
                    },
                    data: {
                        status: 2,
                        encoding: 'raw',
                        data_type: 1,
                        data: '',
                    },
                }));
                clearInterval(_this.handlerInterval);
            }
            var audioData = _this.buffer.read(IFlyBase_1.IFlyBase.BYTE_LENGTH);
            _this.ws.send(JSON.stringify({
                business: {
                    cmd: 'auw',
                    aus: 2,
                    aue: 'raw',
                },
                data: {
                    status: 1,
                    encoding: 'raw',
                    data_type: 1,
                    data: _this.buffer2Base64(audioData),
                },
            }));
        }, 40);
    };
    IFly.prototype.iseResult = function (e) {
        var jsonData = JSON.parse(e.data);
        this.lastCode = jsonData.code;
        if (jsonData.data && jsonData.data.data) {
            var data = js_base64_1.Base64.decode(jsonData.data.data);
            this.showGrade = fast_xml_parser_1.parse(data, {
                attributeNamePrefix: '',
                ignoreAttributes: false,
            });
        }
    };
    IFly.prototype.buffer2Base64 = function (buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };
    IFly.prototype.transaction = function (buffer) {
        var bufTo16kHz = this.to16kHz(buffer);
        var bufTo16BitPCM = this.to16BitPCM(bufTo16kHz);
        return bufTo16BitPCM;
    };
    IFly.prototype.to16kHz = function (buffer) {
        var data = new Float32Array(buffer);
        var fitCount = Math.round(data.length * (16000 / 44100));
        var newData = new Float32Array(fitCount);
        var springFactor = (data.length - 1) / (fitCount - 1);
        newData[0] = data[0];
        for (var i = 1; i < fitCount - 1; i++) {
            var tmp = i * springFactor;
            var before = Math.floor(tmp).toFixed();
            var after = Math.ceil(tmp).toFixed();
            var atPoint = tmp - before;
            newData[i] = data[before] + (data[after] - data[before]) * atPoint;
        }
        newData[fitCount - 1] = data[data.length - 1];
        return newData;
    };
    IFly.prototype.downsampleBuffer = function (buffer, sampleRate, outSampleRate) {
        if (outSampleRate === sampleRate) {
            return buffer;
        }
        if (outSampleRate > sampleRate) {
        }
        var sampleRateRatio = sampleRate / outSampleRate;
        var newLength = Math.round(buffer.length / sampleRateRatio);
        var result = new Int16Array(newLength);
        var offsetResult = 0;
        var offsetBuffer = 0;
        while (offsetResult < result.length) {
            var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
            var accum = 0, count = 0;
            for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
                accum += buffer[i];
                count++;
            }
            result[offsetResult] = Math.min(1, accum / count) * 0x7fff;
            offsetResult++;
            offsetBuffer = nextOffsetBuffer;
        }
        return result.buffer;
    };
    IFly.prototype.to16BitPCM = function (input) {
        var dataLength = input.length * (16 / 8);
        var dataBuffer = new ArrayBuffer(dataLength);
        var dataView = new DataView(dataBuffer);
        var offset = 0;
        for (var i = 0; i < input.length; i++, offset += 2) {
            var s = Math.max(-1, Math.min(1, input[i]));
            dataView.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
        return new Int8Array(dataView.buffer);
    };
    IFly.BUFFER_LENGTH = 20 * 1024 * 1024;
    return IFly;
}(IFlyBase_1.IFlyBase));
exports.IFly = IFly;
//# sourceMappingURL=IFly.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/audio/IFly.js
// module id = kinH
// module chunks = 0